import { AsnClientPersistenceEventArgument } from "~/web-shared-components/asn1/EUCSrv/stubs/ENetUC_ClientPersistence";

import custLabelInitialData from "../../files/CustomLabelsInitial.json";
import { ICustomerLabels } from "../../models/ModelContent";

export const GetCustomLabels = (
	asnClientPersistenceEventArgument: AsnClientPersistenceEventArgument
): ICustomerLabels | undefined => {
	let custLabels: ICustomerLabels = custLabelInitialData as unknown as ICustomerLabels;
	if (
		asnClientPersistenceEventArgument &&
		asnClientPersistenceEventArgument.changedItems &&
		asnClientPersistenceEventArgument.changedItems[0] &&
		asnClientPersistenceEventArgument.changedItems[0].data
	) {
		const requestData: ICustomerLabels = JSON.parse(
			asnClientPersistenceEventArgument.changedItems[0].data
		) as ICustomerLabels;

		if (
			requestData &&
			Object.prototype.hasOwnProperty.call(requestData, "CustLabels") &&
			requestData.CustLabels.length !== undefined &&
			requestData.CustLabels.length > 0
		) {
			custLabels = requestData;
			console.log("Downloading Customer Label Configurations.");
		}
	} else console.log("No configurations available for customer label, using initial configurations.");

	return custLabels;
};
